// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__H4CR-","checkboxCol":"Table_checkboxCol__2Mp7n","emailCol":"Table_emailCol__37ZaS","actionCol":"Table_actionCol__2_tIe"};